var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWednesday = function SvgWednesday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      boxShadow: "0 0 7px #bebebea3",
      margin: "0 6px",
      borderRadius: 5
    },
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "m8.668 16.5-2.42-8.727h1.384l1.7 6.758h.081l1.769-6.758h1.372l1.768 6.763h.081L16.1 7.773h1.39L15.064 16.5h-1.325l-1.837-6.537h-.068L9.997 16.5z"
  })));
};
export default SvgWednesday;